import type { App } from "vue";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

/**
 * 全局注册 Element Plus 所有图标组件
 * 注册后可直接在模板里使用 <User />、<Lock />、<CaretBottom /> 等
 *
 * 备注：unplugin-vue-components 的 ElementPlusResolver 不会自动解析独立图标，
 *      因此这里集中注册一次。如果将来想做 tree-shaking，可改为按需 import。
 */
export function setupElementIcons(app: App) {
    for (const [name, component] of Object.entries(ElementPlusIconsVue)) {
        app.component(name, component);
    }
}
